@import './pn-sidenav-common.scss';
@import '../../../globals/main.scss';

body[data-siteheader-sidemenuopen='true'] {
  max-height: 100vh;
  overflow: hidden;
  @media screen and (min-width: $sidenav-media-smalldesktop) {
    max-height: initial;
    overflow: initial;
  }
}

pn-sidenav {
  display: block;
  height: auto;
  width: 100vw;
  padding: 0 1.6rem;
  background-color: $white;
  z-index: 6;
  transform: translateX(-100vw);
  transition: transform 0.2s 0s;
  transition-property: transform, visibility;
  flex-flow: column;
  visibility: hidden;
  position: fixed;
  overflow: auto;
  top: 10.2rem;
  bottom: 0;
  left: 0;

  &[open='true'] {
    visibility: visible;
    transform: none;
  }

  @media screen and (min-width: $sidenav-media-tablet) {
    top: 15.3rem;
  }

  @media screen and (min-width: $sidenav-media-abovemobilemode) {
    position: relative;
    transform: none;
    visibility: visible;
    top: 0;
    z-index: inherit;
    width: 100%;
    padding: 0;
    height: auto;
    bottom: auto;
    left: auto;
  }
  // transition:transform .15s ease, opacity .10s ease;
  // transform: translateX(-100%);
  // opacity:0;
  // &[open="true"] {
  //     transform:none;
  //     opacity:1;
  // }

  // @media screen and (min-width: $sidenav-media-abovemobilemode) {
  //     transform:none;
  //     opacity:1;
  // }
}

.sidenav {
  // transition:transform .15s ease, opacity .10s ease;
  // transform: translateX(-100%);
  // opacity:0;
  // [open="true"] > & {
  //     transform:none;
  //     opacity:1;
  // }

  // @media screen and (min-width: $sidenav-media-abovemobilemode) {
  //     transform:none;
  //     opacity:1;
  // }
  // height: auto;
  // width: 100vw;
  // background-color: $white;
  // z-index: 3;
  // transform: translateX(100vw);
  // transition: transform 0.2s 0s;
  // transition-property: transform, visibility;
  // display:flex;
  // flex-flow: column;
  // visibility: hidden;
  // position: fixed;
  // top: 15.3rem;
  // bottom: 0;
  // left:0;

  [open='true'] > & {
    // visibility: visible;
    // transform: translateX(0);
  }
}
